import { render, staticRenderFns } from "./ClinicPatientsModal.vue?vue&type=template&id=1a2126f7&scoped=true"
import script from "./ClinicPatientsModal.vue?vue&type=script&lang=js"
export * from "./ClinicPatientsModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicPatientsModal.vue?vue&type=style&index=0&id=1a2126f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2126f7",
  null
  
)

export default component.exports